
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "vue", version: "3.5.38", factory: function() { return function() { return __webpack_require__(745); }; }, eager: 1, singleton: 1, requiredVersion: "3.5.38" }] }, uniqueName: "clientapp" };
__webpack_require__.I = __webpack_require__.I || function() { throw new Error("should have __webpack_require__.I") }
